/**
 * HighlightFeature - Highlight links, headers, or interactive elements
 * Modes: links, headers, elements
 */
import BaseFeature from './BaseFeature.js';

export default class HighlightFeature extends BaseFeature {
    constructor(widget, options = {}) {
        super(widget, options);
        this.mode = options.mode || 'links';
        this.cssClassMap = {
            links: 'dhA11y-highlight-links',
            headers: 'dhA11y-highlight-headers',
            elements: 'dhA11y-highlight-elements'
        };
    }

    enable() {
        super.enable();
        const cls = this.cssClassMap[this.mode];
        if (cls) {
            this.addBodyClass(cls);
        }
    }

    disable() {
        super.disable();
        const cls = this.cssClassMap[this.mode];
        if (cls) {
            this.removeBodyClass(cls);
        }
    }
}
